export const APP_FONT_SIZE_EXTRA_SMALL = 12;
export const APP_FONT_SIZE_SMALL = 13;
export const APP_FONT_SIZE_MEDIUM = 14;
export const APP_FONT_SIZE_LARGE = 15;
export const APP_FONT_SIZE_EXTRA_LARGE = 16;
